import {Pipe, PipeTransform} from "@angular/core";
import {ZonedDateTime} from "@js-joda/core";
import {ZonedDateTimeUtil} from '../utils/zoned-date-time.util';

@Pipe({
  name: 'zonedDateTimeFormat',
})
export class ZonedDateTimeFormatterPipe implements PipeTransform {

  transform(datetime: ZonedDateTime, format: string = 'dd.MM.yyyy HH:mm:ss'): string {
    if (!datetime) {
      return '';
    }
    try {
      return ZonedDateTimeUtil.format(datetime, format);
    } catch (error) {
      console.error('Error formatting ZonedDateTime:', error);
      return '';
    }
  }
}
